export const ACCESSTOKEN = 'access-token'
export const EXPIRETOKEN = 'expire-token'
export const REFRESHTOKEN = 'refresh-token'
export const USERINFOS = 'user-infos'
export const USER_FAVORITES_ENTERPRISES = 'user-favorites-enterprises'
